import { useEffect, useRef, useState } from 'react';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import { useInView } from 'react-intersection-observer';

const galleryImages = [
  {
    src: 'img/gallery/gallery1.jpg',
    title: 'You can add caption to pictures.',
    category: 'dogscats',
  },
  {
    src: 'img/gallery/gallery2.jpg',
    title: 'You can add caption to pictures.',
    category: 'other',
  },
  {
    src: 'img/gallery/gallery3.jpg',
    title: 'You can add caption to pictures.',
    category: 'dogscats',
  },
  {
    src: 'img/gallery/gallery4.jpg',
    title: 'You can add caption to pictures.',
    category: 'other',
  },
  {
    src: 'img/gallery/gallery5.jpg',
    title: 'You can add caption to pictures.',
    category: 'dogscats',
  },
  {
    src: 'img/gallery/gallery6.jpg',
    title: 'You can add caption to pictures.',
    category: 'other',
  },
  {
    src: 'img/gallery/gallery7.jpg',
    title: 'You can add caption to pictures.',
    category: 'dogscats',
  },
  {
    src: 'img/gallery/gallery8.jpg',
    title: 'You can add caption to pictures.',
    category: 'other',
  },
  {
    src: 'img/gallery/gallery9.jpg',
    title: 'You can add caption to pictures.',
    category: 'dogscats',
  },
  {
    src: 'img/gallery/gallery10.jpg',
    title: 'You can add caption to pictures.',
    category: 'other',
  },
  {
    src: 'img/gallery/gallery11.jpg',
    title: 'You can add caption to pictures.',
    category: 'dogscats',
  },
  {
    src: 'img/gallery/gallery12.jpg',
    title: 'You can add caption to pictures.',
    category: 'other',
  },
];

const filters = [
  { label: 'All', filter: '*' },
  { label: 'Dogs and Cats', filter: '.dogscats' },
  { label: 'Other Pets', filter: '.other' },
];

function GalleryIsotope({ onFilterChange }) {
  const gridRef = useRef(null);
  const [isotope, setIsotope] = useState(null);
  const { ref: inViewRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const setRefs = el => {
    gridRef.current = el;
    inViewRef(el);
  };

  useEffect(() => {
    if (!gridRef.current) return;

    imagesLoaded(gridRef.current, () => {
      const iso = new Isotope(gridRef.current, {
        itemSelector: '.isotope-item',
        layoutMode: 'masonry',
      });
      setIsotope(iso);
    });
  }, []);

  useEffect(() => {
    if (isotope && inView) {
      isotope.layout();
    }
  }, [isotope, inView]);
  const [activeFilter, setActiveFilter] = useState('*');

  const handleClick = (e, filter) => {
    e.preventDefault();
    setActiveFilter(filter);
    if (onFilterChange) onFilterChange(filter); // Optional callback
  };

  return (
    <div>
      {/* centered Gallery navigation */}
      <ul className="nav nav-pills cat center-nav">
        {filters.map(item => (
          <li key={item.filter} className="nav-item">
            <a
              href="#"
              className={`nav-link ${
                activeFilter === item.filter ? 'active' : ''
              }`}
              onClick={e => handleClick(e, item.filter)}
              data-filter={item.filter}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
      <div id="gallery-isotope" className="row mt-5" ref={setRefs}>
        {galleryImages.map((img, index) => (
          <div
            key={index}
            className={`isotope-item col-lg-3 col-sm-6 col-md-6 ${img.category}`}
          >
            <div className="gallery-thumb">
              <img
                className="img-fluid"
                src={img.src}
                alt={`Gallery ${index + 1}`}
              />
              <a href={img.src} title={img.title}>
                <span className="overlay-mask"></span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GalleryIsotope;
